import { createContext, useContext } from 'react';

export const UserIdContext = createContext<string>('');

export const useUserId = () => useContext(UserIdContext);

export const ImsTokenContext = createContext<string>('');

export const useImsToken = () => useContext(ImsTokenContext);
